import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { auth, db } from "config/firebaseConfig";
import React from "react";
import { createContext, useContext, useEffect, useState } from "react";

import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();
const AuthProvider = ({ children }) => {
  const [user, setUser] = useState();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (cred) => {
      if (cred) {
        const user = await getDoc(doc(db, `users/${cred.email}`)).then(
          (snapshot) => {
            return snapshot.data();
          }
        );

        setUser(user);
      } else {
        setUser(null);
      }
    });
    return unsub;
  }, []);

  const login = async (username, password) => {
    try {
      const result = await signInWithEmailAndPassword(
        auth,
        username,
        password
      ).then((cred) => {
        if (cred) {
          return cred.user;
        }
      });
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const logout = async () => {
    console.log("success");
    try {
      await signOut(auth);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
